export const PLACE_COORDINATES_ENDPOINT =
  '/api/dealers/place-coordinates/' as const;
export const AOR_RETAILERS_ENDPOINT = '/api/dealers/aor-retailers/' as const;
export const ADDRESS_AUTOCOMPLETE_ENDPOINT =
  '/api/dealers/auto-complete/' as const;
